import { Component } from '@angular/core';
import { NavController, NavParams, NavOptions } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data-provider'
import { HomePage } from '../home/home';
/**
 * Generated class for the Welcome page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public shared: SharedDataProvider) {
  }

  ionViewDidLoad() {
    setTimeout(() => {

      let navOpt: NavOptions = {};
      navOpt.animate = true;
      navOpt.animation = 'wp-transition';
      navOpt.duration = 1000;
      navOpt.direction = 'fade';
      this.navCtrl.push(HomePage, {}, navOpt).then(() => {
        // first we find the index of the current view:
        const startIndex = this.navCtrl.getActive().index - 1;
        // then we remove it from the navigation stack
        this.navCtrl.remove(startIndex);
      });;
    }, 2000);
  }

}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts